module.exports = __webpack_public_path__ + "9de36409.svg";